import React from 'react';
import { resolveFileUrl } from '../../utils/fileUrl';
import fallbackLogo from '../../assets/images/login-logo.png';

const RED='#c31f36';
const BROWN='#8B4A1B';
const text=v=>(v===undefined||v===null?'':String(v).trim());
const first=(...values)=>values.map(text).find(Boolean)||'';
const employeeCode=employee=>first(employee?.showEmployeeId,employee?.showId,employee?.permanentEmployeeId,employee?.permId,employee?.tempEmployeeId,employee?.tempId,employee?.employeeCode,employee?.code,employee?.id);
const formatDate=value=>{if(!value)return'-';if(typeof value==='string'&&/^\d{4}-\d{2}-\d{2}$/.test(value)){const[y,m,d]=value.split('-');return`${d}-${m}-${y}`;}const date=new Date(value);return Number.isNaN(date.getTime())?text(value):`${String(date.getDate()).padStart(2,'0')}-${String(date.getMonth()+1).padStart(2,'0')}-${date.getFullYear()}`;};
const normalizeBodyHtml=(html='')=>{let output=String(html||'');output=output.replace(/<h[1-4][^>]*>\s*Offer\s+Letter\s*<\/h[1-4]>/i,'');output=output.replace(/(?:<p[^>]*>\s*(?:<strong>|<b>)?\s*Authorized\s+Signatory\s*(?:<\/strong>|<\/b>)?\s*<\/p>\s*)$/i,'');output=output.replace(/(?:<div[^>]*>\s*(?:<strong>|<b>)?\s*Authorized\s+Signatory\s*(?:<\/strong>|<\/b>)?\s*<\/div>\s*)$/i,'');return output.trim();};

export default function OfferLetterDocumentPreview({html,company,employee,outlet,letter,status,title='OFFER LETTER'}){
  const resolvedCompany=company||employee?.company||letter?.company||{};
  const resolvedOutlet=outlet||employee?.outlet||letter?.outlet||{};
  const themeColor=resolvedCompany?.themeColor==='brown'?BROWN:RED;
  const companyName=first(resolvedCompany?.name,'Company');
  const address=first(resolvedCompany?.address,resolvedOutlet?.address);
  const email=text(resolvedCompany?.email);
  const phone=first(resolvedCompany?.phone,resolvedOutlet?.mobile,resolvedOutlet?.phone);
  const contactLine=[email&&`Email: ${email}`,phone&&`Phone: ${phone}`].filter(Boolean).join(' | ');
  const logoSrc=resolveFileUrl(resolvedCompany?.logoUrl||resolvedCompany?.logoKey||resolvedCompany?.companyLogo||resolvedCompany?.logo)||fallbackLogo;
  const [logoFailed,setLogoFailed]=React.useState(false);
  React.useEffect(()=>{setLogoFailed(false);},[resolvedCompany?.logoUrl,resolvedCompany?.logoKey,resolvedCompany?.companyLogo,resolvedCompany?.logo]);
  const initial=(companyName.charAt(0)||'C').toUpperCase();
  const normalizedBodyHtml=normalizeBodyHtml(html);
  return <div className="offer-letter-a4" style={{'--offer-theme':themeColor}}>
    <div className="offer-letter-sheet">
      <header className="offer-letter-header">
        <div className="offer-letter-logo">{logoSrc&&!logoFailed?<img src={logoSrc} alt={`${companyName} logo`} onError={()=>setLogoFailed(true)}/>:<span>{initial}</span>}</div>
        <div className="offer-letter-company-block">
          <h1 className="offer-letter-company-name">{companyName}</h1>
          {address&&<div className="offer-letter-company-line">{address}</div>}
          {contactLine&&<div className="offer-letter-company-line">{contactLine}</div>}
        </div>
      </header>
      <div className="offer-letter-divider-wrap"><div className="offer-letter-divider-top"/><div className="offer-letter-divider-bottom"/></div>
      <div className="offer-letter-title-pill">{title}</div>
      <div className="offer-letter-meta-strip">
        {letter?.letterNo&&<div><b>Letter No:</b> {letter.letterNo}</div>}
        <div><b>Issue Date:</b> {formatDate(letter?.issueDate)}</div>
        {employee?.name&&<div><b>Employee:</b> {employee.name}</div>}
        {employeeCode(employee)&&<div><b>Employee Code:</b> {employeeCode(employee)}</div>}
      </div>
      <main className="offer-letter-body" dangerouslySetInnerHTML={{__html:normalizedBodyHtml||'<p class="text-muted">No preview yet.</p>'}} />
      <div className="offer-letter-signatures">
        <div className="offer-letter-signature-block"><div className="offer-letter-signature-line"/><div>Employee Acceptance</div></div>
        <div className="offer-letter-signature-block"><div className="offer-letter-signature-line"/><div>Authorized Signatory</div></div>
      </div>
      <footer className="offer-letter-footer">
        <div className="offer-letter-footer-divider"/>
        <div className="offer-letter-footer-company">{companyName}</div>
        {(address||contactLine)&&<div>{[address,contactLine].filter(Boolean).join(' | ')}</div>}
        <div className="offer-letter-footer-note">This is a system generated offer letter.</div>
      </footer>
    </div>
  </div>;
}
